import { Tooltip } from "antd";
import { Container, StyledTag } from "./styles";

interface PayTagsProps {
  payed: boolean;
  hidePayed?: boolean;
  emittedTitle?: string;
}

export const PayTags: React.FC<PayTagsProps> = ({
  payed,
  hidePayed,
  emittedTitle,
}) => {
  return (
    <Container>
      <StyledTag color="var(--ant-primary-color)">
        {emittedTitle ?? "Emitida"}
      </StyledTag>
      {!hidePayed && (
        <>
          {payed ? (
            <StyledTag color="var(--ant-success-color)">Pago</StyledTag>
          ) : (
            <Tooltip
              placement="bottom"
              title="Confirmar pagamento na aba Histórico."
            >
              <StyledTag
                color="var(--ant-warning-color)"
                style={{ color: "#272a30" }}
              >
                DARF emitido e não pago
              </StyledTag>
            </Tooltip>
          )}
        </>
      )}
    </Container>
  );
};
